import { useParams, useSearchParams } from 'react-router-dom'
import { OpenSectionModal } from '~pages/pages-behind-login/onboarded-vessel/questionnaire-page-v2/components/open-section-modal'
import { ApiRoutes } from '~api'
import { IQuestionnaireListSection } from '~components/organisms/lists/vessel-questionnaires'
import { IQuestionnaireSection, IQuestionnaireField } from '~api/vessels/read'
import { useApi } from '../../../../hooks/use-api'

export const FlowModal = () => {
  const { vesselId } = useParams()
  const [searchParams] = useSearchParams()
  const flow = searchParams.get('flow')

  const {
    data: flowData,
    isLoading,
    isValidating,
    mutate,
  } = useApi<{
    name: string
    sections: IQuestionnaireSection[]
  }>(vesselId && flow ? ApiRoutes.Vessels.flow : '', {
    vesselId,
    flowId: flow || undefined,
  })

  if (isLoading || isValidating) {
    return null
  }

  const uniqueSections = [
    ...new Set(flowData?.sections?.map((section) => section.name) || []),
  ]

  const allEarningsSimFields = () => {
    const aggregate: IQuestionnaireField[] = []
    flowData?.sections?.forEach((section) => {
      section.fields.forEach((field) => {
        aggregate.push({
          ...field,
          sectionTitle: section.name,
          sectionId: section.id,
        })
      })
    })
    return aggregate
  }

  const flowToName = () =>
    flow?.replace(/-/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase()) ||
    ''

  const flowDataFlattenedSectionsAndFields = {
    ...flowData,
    name: flowToName(),
    sections: [
      {
        ...flowData?.sections[0],
        id: flow,
        name: flowToName(),
        fields: allEarningsSimFields(),
      },
    ] as IQuestionnaireListSection[],
  }

  return flowDataFlattenedSectionsAndFields?.sections?.[0]?.name ? (
    <OpenSectionModal
      manualQuestions={[flowDataFlattenedSectionsAndFields]}
      uniqueSections={uniqueSections}
      revalidate={mutate}
    />
  ) : null
}
